import { Button } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { setShowCreatePlaceModal } from "../../store";
import { COLOR_BLACK, COLOR_PRIMARY } from "../../utils/styles";
import { Add } from "@mui/icons-material";

function CreatePlaceButton({ sx = {} }) {
  const username = useSelector((state) => state.user.profile.username);
  const dispatch = useDispatch();
  return (
    <Button
      variant="solid"
      startDecorator={<Add />}
      onClick={() => {
        if (username === null) {
          alert("please create a user account");
        } else {
          dispatch(setShowCreatePlaceModal(true));
        }
      }}
      sx={{
        backgroundColor: COLOR_BLACK,
        "&:hover": {
          // override default onhover color
          backgroundColor: COLOR_PRIMARY,
        },
        ...sx,
      }}
    >
      Add Restaurant
    </Button>
  );
}

export default CreatePlaceButton;
